import * as React from "react";
import { useContext, useMemo } from "react";
import { MenuItem } from "components/bootstrap";
import WidgetFocusContext from "views/components/contexts/WidgetFocusContext";
import useViewsDispatch from "views/stores/useViewsDispatch";
import useWidgetActions from "views/components/widgets/useWidgetActions";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import generateId from "logic/generateId";
const createHandler = (action, setComponents) => {
  if (action.action) {
    return action.action;
  }
  if (action.component) {
    const ActionComponent = action.component;
    return (widget, contexts) => () => {
      const id = generateId();
      const onClose = () => setComponents(({ [id]: _, ...rest }) => rest);
      const renderedComponent = /* @__PURE__ */ React.createElement(ActionComponent, { key: action.type, widget, contexts, onClose });
      setComponents((actionComponents) => ({
        [id]: renderedComponent,
        ...actionComponents
      }));
      return Promise.resolve();
    };
  }
  return () => () => Promise.resolve();
};
const ExtraDropdownWidgetActions = ({ widget, setComponents }) => {
  const widgetFocusContext = useContext(WidgetFocusContext);
  const pluginWidgetActions = useWidgetActions();
  const dispatch = useViewsDispatch();
  const sendTelemetry = useSendTelemetry();
  const extraWidgetActions = useMemo(
    () => pluginWidgetActions.filter(
      ({ isHidden = () => false, position }) => !isHidden(widget) && (position === "dropdown" || position === void 0)
    ).map((action) => {
      var _a, _b;
      const handler = createHandler(action, setComponents);
      const _onSelect = () => {
        sendTelemetry(TELEMETRY_EVENT_TYPE.SEARCH_WIDGET_ACTION.SEARCH_WIDGET_EXTRA_ACTION, {
          app_section: "search-widget",
          app_action_value: action.type
        });
        dispatch(handler(widget, { widgetFocusContext }));
      };
      const disabled = (_b = (_a = action.disabled) == null ? void 0 : _a.call(action)) != null ? _b : false;
      return /* @__PURE__ */ React.createElement(MenuItem, { key: `${action.type}-${widget.id}`, disabled, onSelect: _onSelect }, action.title(widget));
    }),
    [dispatch, pluginWidgetActions, sendTelemetry, setComponents, widget, widgetFocusContext]
  );
  return extraWidgetActions.length > 0 ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(MenuItem, { divider: true }), extraWidgetActions) : null;
};
export default ExtraDropdownWidgetActions;
